import React, { useState } from 'react'
import { usePriceChangeAlertFlag } from '../../../../hooks/usePriceChangeAlert'
import { priceChangeAlertMessage } from '../../../shared/subscription-constants'
import Modal from '../../../../components/modal'
import Button from '../../../../components/button'
import styles from './temp-price-alert.css'

/**
 * temp price change alert which display the same service msg,
 * when user enter the step2 price table in sign up journey.
 */
const TempPriceAlert = () => {
  const headerText = priceChangeAlertMessage.modalHeader
  const msgText = priceChangeAlertMessage.modalMessage
  const showPriceChangeAlert = usePriceChangeAlertFlag()
  const [isModalClosed, setModalClosed] = useState(false)
  const closeModal = () => {
    setModalClosed(true)
  }

  if (!showPriceChangeAlert || isModalClosed) {
    return null
  }
  return (
    <Modal>
      <div className={styles.contentBox}>
        <div className={styles.contentFrame}>
          <h3 className={styles.header}>{headerText}</h3>
          <div className={styles.text}>{msgText}</div>
          <div className={styles.buttonGroup}>
            <Button
              onClick={closeModal}
              className={styles.button}
              text="OK"
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default TempPriceAlert
